export const CAUSED_BY_FRONT = 'Caused by Frontend';
export const CAUSED_BY_BACK = 'Caused by Back';
export const CAUSED_BY_CORS = 'Caused by CORS';
export const CAUSED_BY_TIMEOUT = '504 Timeout';
export const ERROR_CORS = 'Network Error';

export const TIME_LIMIT = 29;

export const LOGS_UPDATE = 'LOGS_UPDATE';
export const SET_STEP_LOGS = 'SET_STEP_LOGS';
export const LOGS_CONFIG = 'LOGS_CONFIG';
export const SET_SUCCESS_LOGS = 'SET_SUCCESS_LOGS';
export const SET_ERROR_LOGS = 'SET_ERROR_LOGS';
export const SET_LOAD_AUDITORY = 'SET_LOAD_AUDITORY';
export const SET_ID_AUDITORY = 'SET_ID_AUDITORY';

export const URL_AUDITORY = '/registro/auditoria';
export const apinameUtilitarios = 'LEAD';

export const GENERIC_MESSAGE_ERROR = [
  'Script error.',
  'frameWrapper',
  "Cannot read properties of undefined (reading 'frameWrapper')",
  't.find is not a function',
  "Cannot set properties of undefined (setting 'h_content-type')",
  'h_content-type',
];

// monitoring constants

export const MONITORING_META = 'meta';
export const MONITORING_PAGE = 'page';
export const MONITORING_USER = 'user';
export const MONITORING_EVENT = 'reportEvent';
export const MONITORING_ERROR = 'reportError';
export const MONITORING_TERMINATESESSION = 'terminateSession';
export const MONITORING_CAPTUREHADERS = 'captureHeaders';

export const MONITORING_KEY_AUDITORY = 'auditoryId';
export const MONITORING_KEY_ACTIONNAME = 'actionName';
export const MONITORING_KEY_ACTIONCOMPONENT = 'actionComponent';
export const MONITORING_KEY_ACTIONAPI = 'actionApi';
export const MONITORING_KEY_ORIGINREPORT = 'originReport';
export const MONITORING_KEY_VERSION = 'version';
export const MONITORING_KEY_PRODUCT = 'product';
export const MONITORING_KEY_TRACEID = 'traceId';
export const MONITORING_KEY_USER = 'user';
export const MONITORING_KEY_USERTAG = 'userTag';
export const MONITORING_KEY_PHONE = 'phone';
export const MONITORING_KEY_PLATE = 'plate';
export const MONITORING_KEY_EMAIL = 'email';
export const MONITORING_KEY_COTIZATION = 'idecotizacion';

export const MONITORING_CURRENTUSER = 'currentUser';
export const MONITORING_NOMAIL = 'nomail@gmail.com';
export const MONITORING_REPORT_MESSAGE = 'Error en post';
export const MONITORING_BEFOREPOST_MESSAGE = 'Error luego de post';
export const MONITORING_FRONTEND_MESSAGE = 'Error en frontend';
